//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadLocalImage } from '@/utils/uploadImage'
import { resolveMediaUrl } from '@/utils/mediaUrl'

export default {
  name: 'ImagePicker',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '点击添加图片' },
    clearable: { type: Boolean, default: true },
    allowMaterial: { type: Boolean, default: true },
    imageType: { type: String, default: 'scene' }
  },
  data () {
    return {
      uploading: false,
      materialShow: false,
      materials: [],
      cat: 'all',
      cats: [
        { k: 'all', n: '全部' },
        { k: 'home', n: '家居' },
        { k: 'school', n: '校园' },
        { k: 'food', n: '美食' },
        { k: 'travel', n: '旅行' }
      ]
    }
  },
  computed: {
    previewUrl () {
      return resolveMediaUrl(this.value)
    }
  },
  methods: {
    mediaUrl (u) {
      return resolveMediaUrl(u)
    },
    pickFile () {
      if (this.uploading) return
      this.$refs.fileInput && this.$refs.fileInput.click()
    },
    onFileChange (e) {
      const file = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!file) return
      this.uploading = true
      uploadLocalImage(file).then(url => {
        this.$emit('input', url)
        this.$emit('uploaded', url)
        this.$toast && this.$toast('上传成功')
      }).catch(err => {
        this.$toast && this.$toast((err && err.message) || '上传失败')
      }).finally(() => {
        this.uploading = false
      })
    },
    openMaterial () {
      this.materialShow = true
      this.loadMaterial(this.cat)
    },
    loadMaterial (c) {
      this.cat = c
      const q = c && c !== 'all' ? ('?category=' + c) : ''
      this.$ajax.get(this.$api.mpImageSystem + q).then(r => {
        this.materials = r || []
      }).catch(() => { this.materials = [] })
    },
    pickMaterial (img) {
      const url = img.imageUrl || img.image_url
      if (!url) return
      this.$emit('input', url)
      this.$emit('uploaded', url)
      this.materialShow = false
      this.$toast && this.$toast('已选择素材')
    },
    clear () {
      this.$emit('input', '')
      this.$emit('uploaded', '')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/innovation/ImagePicker.vue